module.exports = __webpack_public_path__ + "cross.png?260c9c6535065674bb5e59a73f894abb";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vis/dist/img/network/cross.png
// module id = 564
// module chunks = 0